import { getIframelyData } from '#src/app/shared/api/medias';

import type { MediaHitResolver } from './types';

/**
 * CONTROL arm: the third-party iframely embed, rendered as a cross-origin iframe by `EmbeddedMedia`.
 *
 * Backed by iframely's `/api/oembed` endpoint. This is what production has always done; the treatment
 * arm's `resolveMediaHitCard` is measured against it, so nothing here should change.
 */
export const resolveMediaHitEmbed: MediaHitResolver = async ({ url, utilityContext }) => {
	try {
		const { html } = await getIframelyData({ url, format: 'SMALL' }, utilityContext);
		return { status: 'valid', html, card: null };
	} catch {
		return { status: 'invalid' };
	}
};
